export const HISTORY_CALLER_STATUS = {
  CALLING: 0,
  THE_CALL_ESTABLISHED: 1,
  THE_CALL_NOT_ESTABLISHED: 2,
  THE_CALL_FINISHED_NORMALLY: 3,
  TIMEOUT: 4,
  CANCEL: 5,
} as const

export const HISTORY_RECEIVER_STATUS = {
  RECEIVED: 0,
  THE_CALL_ESTABLISHED: 1,
  THE_CALL_NOT_ESTABLISHED: 2,
  THE_CALL_FINISHED_NORMALLY: 3,
  TIMEOUT: 4,
  REJECT: 5,
} as const

export const REDIAL_EXPIRED_TIME = 1000 * 60 * 5

export const GUEST_ATTENDEE_INDEX = 0
export const CREW_ATTENDEE_INDEX = 1
